
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaGlobe, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
export const socialMediaLinksMMtech = [
    { name: "Facebook", href: "https://www.facebook.com/mmtechly", icon: <FaFacebook /> },
    { name: "WhatsApp", href: "https://wa.me/218911919187", icon: <FaWhatsapp /> },
    { name: "Website", href: "http://mmtech.ly/", icon: <FaGlobe /> },
    { name: "LinkedIn", href: "https://www.linkedin.com/company/mmtechly?trk=organization_guest_main-feed-card_reshare-text&originalSubdomain=ly", icon: <FaLinkedin /> }
];
const MMtech = () => {
    const { t } = useTranslation();
    return (
        <div className=' mmtech  py-5'>
            <div className=' flex-between xs:flex-col md:flex-row gap-8 '>
                <div className='xs:text-center md:text-start hover:text-white transition-all'>
                    {t("copyright")}
                </div>                
                <ul className='flex gap-5 text-2xl'>
                    {
                        socialMediaLinksMMtech.map((item, index) => (
                            <li key={index} className='hover:text-white hover:animate-bounce transition-all'>
                                <Link  to={item.href}>{item.icon}</Link>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

export default MMtech